import styled from 'styled-components'
import { Sizes, Breakpoints, Colors, FontRegular } from './../../utils/variables'

export const Container = styled.div`
    width: 100%;
    max-width: ${Sizes.maxContainerWidth};

    margin: 0 auto;
    padding: 0 30px;

    p {
        width: 100%;
        max-width: ${Sizes.maxContentWidth};

        margin: 0 auto 20px auto;

        &.block-img {
            max-width: none;

            text-align: center;

            img {
                width: 100%;
                max-width: 1000px;
            }
        }
    }

    h2, h3, h4, h5 {
        width: 100%;

        max-width: ${Sizes.maxContentWidth};

        margin: 0 auto 20px auto;

        font-weight: normal;
    }

    h2 {
        ${FontRegular}
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.5px;

        color: ${Colors.blue};

        // text-transform: uppercase;
    }

    h3 {
        font-size: 13px;
        line-height: 20px;
    }

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding: 0;

        h2 {
            font-size: 25px;
            line-height: 35px;
        }

        h3 {
            font-size: 24px;
            line-height: 34px;
        }

        h2, h3, h4, h5, p {
            margin: 0 auto 35px auto;
        }
    }
`